import { BaseDevice } from '../runtime/BaseDevice'
import { DeviceError, DeviceErrorCode } from '../errors/DeviceError'

/**
 * 功能模块基类
 * 所有具体的 Feature (DPI, Lighting, Macro) 都要继承此类
 */
export class FeatureBase {
  constructor(protected device: BaseDevice) {}

  /**
   * 子类未实现的能力统一抛出明确错误，方便 Web 层区分“设备不支持”和普通通信失败。
   */
  protected unsupported(method: string): never {
    throw new DeviceError(
      DeviceErrorCode.NOT_SUPPORTED,
      `${this.device.manifest.model} does not support ${method}`,
    )
  }

  /**
   * 方便访问其他功能模块 (解决耦合)
   * 子类可以直接使用 this.features.lighting 来调用兄弟模块
   */
  protected get features() {
    // 使用 any 绕过类型循环引用的问题，或者在 BaseDevice 里定义通用的 FeatureMap 接口
    return this.device.features || {}
  }
}
